import React from 'react';

const Tagline = () => {
  // Define the tagline text with newlines
  // Use square brackets [ ] to mark letters that should use the tech font
  const fullText = "[O]RT[O]M: [P]RO[D][U]CTI[O]N\n A[G]ENTIC AI\n F[OR] [S]TART[U]P[S]";

  // Process the text to identify tech font letters
  const processText = (text) => {
    const lines = text.split('\n');

    return lines.map(line => {
      const processedLine = [];
      let isTechFont = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];

        if (char === '[') {
          isTechFont = true;
          continue;
        } else if (char === ']') {
          isTechFont = false;
          continue;
        }

        processedLine.push({
          letter: char,
          isTechFont
        });
      }

      return processedLine;
    });
  };

  const lettersByLine = processText(fullText);

  return (
    <div className="container is-fluid mobile-container">
      <div>
        <h1>
          {lettersByLine.map((line, lineIndex) => (
            <React.Fragment key={lineIndex}>
              {line.map((letterObj, letterIndex) => (
                <span
                  key={`${lineIndex}-${letterIndex}`}
                  className={letterObj.isTechFont ? "title--techfont" : ""}
                >
                  {letterObj.letter}
                </span>
              ))}
              {lineIndex < lettersByLine.length - 1 && <br />}
            </React.Fragment>
          ))}
        </h1>
      </div>
    </div>
  );
};

export default Tagline;
